<template>
  <div>
    <dl>
      <dt><Qnumber></Qnumber></dt>
      <dd>{{quasution}}</dd>
    </dl>
    <ul class="modal__shindanQ">
      <li @click.prevent="clickAnswer(0)">
        <label><input type="checkbox" value="c[]">{{answer1}}</label>
      </li>
      <li @click.prevent="clickAnswer(1)">
        <label><input type="checkbox" value="c[]">{{answer2}}</label>
      </li>
    </ul>
  </div>
</template>

<script>
// import Filter from './components/Filter.vue'
// import Vue from 'vue';
// 『イベントバス』のためのインスタンス
// var bus = new Vue();

import Qnumber from './Qnumber.vue'

export default {
  name: 'Quasution',
  components: {
    Qnumber,
  },

  data () {
    return {
      // currentNum: this.$store.state.userSelect.currentQnum,
    }
  },
  computed : {
    currentQuestion : function(){
      var linkId = this.$store.state.userSelect.link;
      return this.$store.state.question.filter(function(item) {
        return item.id === linkId;
      })[0];
    },
    quasution : function(){
      // console.log(this.currentQuestion.question);
      return this.currentQuestion.question;
      // return this.$store.state.question['q'+this.currentNum].text;
    },
    answer1 : function(){
      return this.currentQuestion.links[0].select;
      // return this.$store.state.question['q'+this.currentNum].answer[0].text;
    },
    answer2 : function(){
      return this.currentQuestion.links[1].select;
      // return this.$store.state.question['q'+this.currentNum].answer[1].text;
    },
  },

  methods: {

      clickAnswer: function(num){
        // console.log('clickAnswer',num);
        var userSelect = this.$store.state.userSelect;
        var q = this.currentQuestion;
        var linkId = q.links[num].link;
        var type = q.links[num].type;

        if(linkId == 'fashion-comfort') {
          linkId = (userSelect.type.fashion > userSelect.type.comfort)? userSelect.linkDefaultFashionId : userSelect.linkDefaultComfortId
        }

        // 結果表示
        if(linkId.indexOf('result') != -1) this.$store.commit('setResult', linkId);

        this.$store.commit('setTypeCount', type);
        this.$store.commit('setLink', linkId);
      },
      beforeEnter: function(el) {
        // console.log('before');
        // ここで要素が表示または出現する前の状態を定義します。
      },
  }
}
</script>

<style>
</style>
